function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var generatePokusBodyRequest = function generatePokusBodyRequest(_ref) {
  var lob = _ref.lob,
      isMobile = _ref.isMobile,
      deviceId = _ref.deviceId,
      _ref$extraOptions = _ref.extraOptions,
      extraOptions = _ref$extraOptions === void 0 ? {} : _ref$extraOptions;
  var device = isMobile ? 'mobile' : 'desktop';
  var request = {
    lob: lob,
    user: _extends({
      deviceId: deviceId
    }, extraOptions.user),
    attributes: _extends({
      device_os: device,
      device_type: device
    }, extraOptions.attributes)
  };
  return {
    request: request
  };
};

export { _extends as _, generatePokusBodyRequest as g };
